export default "/1d9e382652752581521279795d444fdb.svg";